module.exports = __webpack_public_path__ + "img/svg - only table.4c2405f9.svg";